
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbRelatorioPrimeiroAcesso extends AppService {

  abstract getAllTenants(filter: AppFilter): Observable<any>;
}